import React from 'react'
import Logo from '../../../assets/logo.png'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'


const Loader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '80vh',
                backgroundColor: '#0f1419',
            }}
        >
            <img src={Logo} alt="Logo" width={120} />
            <CircularProgress 
                disableShrink 
                sx={{ 
                    mt: 6,
                    color: '#ffd700',
                    '& .MuiCircularProgress-circle': {
                        strokeLinecap: 'round',
                    }
                }} 
            />
        </Box>
    )
}

export default Loader
